/**
 * relatoriosBuilder (S4) — relatórios financeiros + acesso ao AVA (read-only).
 *
 * @since S4 (gaps SA→AVA)
 */
import type { $Fetch } from 'ofetch';

import { HttpRelatorioGateway } from '@/infrastructure/http/HttpRelatorioGateway';
import {
  GetRelatorioInadimplentes, GetRelatorioAdimplentes,
  GetRelatorioPagamentosPorPolo, GetRelatorioAcessoAva,
} from '@/application/usecase/RelatorioUseCaseImpl';

export function buildRelatoriosSlice(httpClient: $Fetch) {
  const gateway = new HttpRelatorioGateway(httpClient);

  const useCases = {
    getRelatorioInadimplentes: new GetRelatorioInadimplentes(gateway),
    getRelatorioAdimplentes: new GetRelatorioAdimplentes(gateway),
    getRelatorioPagamentosPorPolo: new GetRelatorioPagamentosPorPolo(gateway),
    getRelatorioAcessoAva: new GetRelatorioAcessoAva(gateway),
  };

  return { useCases };
}
